module.exports = __webpack_public_path__ + "static/img/aggregateTitle.33a3454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aggregateTitle.png
// module id = GkqL
// module chunks = 1